import React from "react";
import config from "../core/config/config";
import domainRouter from "./domainRouter";
import MainRoutes from "./MainRoutes";
import CodeRoutes from "./CodeRoutes";
import CorporativeRoutes from "./CorporativeRoutes";
import PromoRoutes from "./PromoRoutes";
import { MetrikaCounter } from 'react-metrika';

interface IProps {
  className?: string;
}

const SCREENS = {
  [config.giftRoute]: MainRoutes,
  [config.codeRoute]: CodeRoutes,
  [config.corpRoute]: CorporativeRoutes,
  [config.promoRoute]: PromoRoutes,
}

const YM_ACCOUNTS: any = {
  'podarok.prostoapp.ru': 86989752,
  'prosto-meditation.ru': 94588675,
  'corp.prostoapp.ru': 92179976,
}

// export const ymOptions = {
//   clickmap: true,
//   trackLinks: true,
//   accurateTrackBounce: true,
//   webvisor: true,
//   trackHash: true
// }

export const yandexMetrikaCounter = YM_ACCOUNTS[domainRouter.currentHost] || 86989752;

const DomainRoutes: React.FC<IProps> = ({ className }) => {
  const Screen = SCREENS[domainRouter.currentHost];
  /* @ts-ignore */

  // console.log('yandexMetrikaCounters', yandexMetrikaCounters)
  // console.log('domainRouter.currentHost', domainRouter.currentHost)
  return (
    <div className={className}>
      <MetrikaCounter
        id={yandexMetrikaCounter}
        options={{
          trackHash: true,
          webvisor: true
        }}
      />
      {/* {domainRouter.currentHost === 'corp.prostoapp.ru' &&
        
      }
      {domainRouter.currentHost === 'podarok.prostoapp.ru' &&
        <MetrikaCounter
          id={86989752}
          options={{
            trackHash: true,
            webvisor: true
          }}
        />
      }
      {domainRouter.currentHost === 'prosto-meditation.ru' &&
        <MetrikaCounter
          id={94588675}
          options={{
            trackHash: true,
            webvisor: true
          }}
        />
      } */}
      {Screen ? <Screen /> : <MainRoutes />}
    </div>
  );
};

export default DomainRoutes;
